import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconMicOff$1 = /*@__PURE__*/ proxyCustomElement(class WppIconMicOff extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-mic-off", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M3.02426 2.17574C2.78995 1.94142 2.41005 1.94142 2.17574 2.17573C1.94142 2.41004 1.94142 2.78994 2.17573 3.02425L6.79996 7.64858V9.99994C6.79996 11.7672 8.23264 13.1999 9.99994 13.1999C10.6667 13.1999 11.2858 12.996 11.7984 12.6471L12.7151 13.5638C12.014 14.0889 11.1433 14.3999 10.1999 14.3999H9.79994L9.62682 14.3964C7.38752 14.3056 5.59997 12.4615 5.59997 10.1999V9.79994L5.5945 9.71853C5.55477 9.42567 5.30373 9.19995 4.99998 9.19995C4.66861 9.19995 4.39998 9.46857 4.39998 9.79994V10.1999L4.40323 10.389C4.49825 13.1504 6.66655 15.3852 9.39996 15.5853L9.39994 17.3999L9.40542 17.4813C9.44515 17.7742 9.69619 17.9999 9.99994 17.9999C10.3313 17.9999 10.5999 17.7313 10.5999 17.3999L10.6007 15.5853C11.7199 15.5031 12.7443 15.0799 13.5704 14.4191L16.9754 17.8243C17.2098 18.0586 17.5896 18.0586 17.824 17.8243C18.0583 17.59 18.0583 17.2101 17.824 16.9757L3.02426 2.17574ZM10.9249 11.7736C10.6483 11.9182 10.3337 11.9999 9.99994 11.9999C8.89538 11.9999 7.99996 11.1045 7.99996 9.99994V8.84859L10.9249 11.7736ZM11.9999 5.19998V9.4545L13.144 10.5986C13.1807 10.4047 13.1999 10.2046 13.1999 9.99994V5.19998C13.1999 3.43268 11.7672 2 9.99994 2C8.52166 2 7.2775 3.00241 6.91011 4.36458L7.99996 5.45445V5.19998C7.99996 4.09542 8.89538 3.19999 9.99994 3.19999C11.1045 3.19999 11.9999 4.09542 11.9999 5.19998ZM14.1568 11.6115L15.0736 12.5282C15.411 11.8232 15.5999 11.0337 15.5999 10.1999V9.79994L15.5944 9.71853C15.5547 9.42567 15.3037 9.19995 14.9999 9.19995C14.6685 9.19995 14.3999 9.46857 14.3999 9.79994V10.1999L14.3964 10.3731C14.3789 10.806 14.2958 11.222 14.1568 11.6115Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-mic-off-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-mic-off", "wpp-icon-mic-off-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-mic-off-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-mic-off-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconMicOff$1);
      }
      break;
  } });
}

const WppIconMicOff = WppIconMicOff$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconMicOff, defineCustomElement };
